import { FETCH_AGENTS_REQUEST } from 'constants/action_types'

export default function requestAction() {
  return { type: FETCH_AGENTS_REQUEST }
}
